import { getField } from 'vuex-map-fields';

// TYPES
export const SET_FILTERS_DATA_KEY = 'SET_FILTERS_DATA_KEY';
export const SET_FILTER_DESCRIPTION = "SET_FILTER_DESCRIPTION";
export const SET_FILTER_CODE = "SET_FILTER_CODE";
export const CLEAN_FILTER = "CLEAN_FILTER";
export const RESET_FILTERS = "RESET_FILTERS";


// STATE
const state = () => ({
    listFilters: {        
        description: {
            'name': 'description',
            'label': 'Descripción',
            'value': '',
            'type': 'text',
            'icon': 'mdi-file-document',
        },       
        code: {
            'name': 'code',
            'label': 'Código',
            'value': '',
            'type': 'text',
            'icon': 'mdi-file-document',
        },
    }
});

// GETTERS
const getters = {
    listFilters: state => state.listFilters,
    getField
}

// ACTIONS
const removeAllFilters = ({commit},p) => {
    let value=''
    let text=''
    commit(SET_FILTER_DESCRIPTION, value);   
    commit(SET_FILTER_CODE, value);
}

const updateObject = ({commit}, {key,value,text}) => {
    if(key=='description')
        commit(SET_FILTER_DESCRIPTION, value);
    if(key=='code')
        commit(SET_FILTER_CODE, value);
    
};

const setFilterDescription = ({commit}, value) => {
    commit(SET_FILTER_DESCRIPTION, value);
};

const setFilterCode = ({commit}, value) => {
    commit(SET_FILTER_CODE, value);
};

const setFilter = ({commit}, {key, value}) => {
    commit(SET_FILTERS_DATA_KEY, {key, value});
};

const cleanFilter = ({commit}, key) => {
    commit(CLEAN_FILTER, key);
};

const resetFilters = ({commit}) => {
    commit(RESET_FILTERS);
};

export const actions = {   
    setFilterDescription,    
    setFilterCode,
    setFilter,
    cleanFilter,
    resetFilters,
    updateObject,
    removeAllFilters,
}

// MUTATIONS
const mutations = {
    [SET_FILTERS_DATA_KEY](state, {key, value}) {
        state.listFilters[key].value = value;
    },    
    [SET_FILTER_DESCRIPTION](state, value) {
        state.listFilters['description'].value = value;
    },   
    [SET_FILTER_CODE](state, value) {
        state.listFilters['code'].value = value;
    },
    [CLEAN_FILTER](state, key) {
        state.listFilters[key].value = '';
    },
    [RESET_FILTERS](state) {
        for (const key in state.listFilters) {
            state.listFilters[key].value = '';
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}